import styles from "./Dashboard.module.scss";
import Calendar from "./Calendar/Calendar";
import Plan from "./Components/Plan";
import Tasks from "./Components/Tasks";
import Raport from "./Components/Raport";
import Sale from "./Components/Sale";
import Realization from "./Components/Realization";
import Abc from "./Components/Abc";
import HeaderSale from "./Components/HeaderSale";
import HeaderFree from "./Components/HeaderFree";
import HeaderClients from "./Components/HeaderClients";
import Contact from "./Components/Contact";
import { useEffect, useState } from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

export default function Dashboard() {
  const [calendarDate, setCalendarDate] = useState(
    new Date(`${new Date().getFullYear()}/${new Date().getMonth() + 1}`)
  );
  const [eventDate, setEventDate] = useState(new Date());
  const [month, setMonth] = useState();
  const [statistics, setStatistics] = useState(null);
  const [events, setEvents] = useState(null);
  const [event, setEvent] = useState(null);

  const changeDay = (data) => {
    const splitDate = data.split("-");
    setEventDate(new Date(`${splitDate[1]}-${splitDate[0]}-${splitDate[2]}`));
  };
  const changeMonth = (char) => {
    let newDate;
    if (char === "+") {
      newDate = new Date(
        calendarDate.getFullYear(),
        calendarDate.getMonth() + 1,
        1
      );
    } else {
      newDate = new Date(
        calendarDate.getFullYear(),
        calendarDate.getMonth() - 1,
        1
      );
    }
    setCalendarDate(newDate);
  };

  useEffect(() => {
    if (events !== null)
      setEvent(
        events.filter((item) => {
          let date = new Date(item.date);
          return date.getDate() === eventDate.getDate();
        })
      );
  }, [eventDate, events]);
  const getMonthName = () => {
    let nr = calendarDate.getMonth();
    const names = [
      "Styczeń",
      "Luty",
      "Marzec",
      "Kwiecień",
      "Maj",
      "Czerwiec",
      "Lipiec",
      "Sierpień",
      "Wrzesień",
      "Październik",
      "Listopad",
      "Grudzień",
    ];
    setMonth(names[nr]);
  };
  useEffect(() => {
    getMonthName();
  }, [changeMonth]);
  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapperMain}>
        <div className={styles.wrapperHeader}>
          <div className={styles.headerWrapper}>
            <HeaderSale data={statistics} />
          </div>
          <div className={styles.headerWrapper}>
            <HeaderFree />
          </div>
          <div className={styles.headerWrapper}>
            <HeaderClients data={statistics} />
          </div>
        </div>
        <div className={styles.top}>
          <div className={`${styles.topContainer} ${styles.raportContainer}`}>
            <Raport data={statistics} />
          </div>
          <div
            className={`${styles.topContainer} ${styles.realizationContainer}`}
          >
            <Realization data={statistics} />
          </div>
        </div>
        <div className={styles.bottom}>
          <div
            className={`${styles.bottomContainer} ${styles.contactContainer}`}
          >
            <Contact />
          </div>
          <div className={`${styles.bottomContainer} ${styles.tasksContainer}`}>
            <Tasks />
          </div>
          <div className={`${styles.bottomContainer} ${styles.saleContainer}`}>
            <Sale />
          </div>
        </div>
      </div>
      <div className={styles.wrapperSecond}>
        <div
          className={`${styles.wrapperSecondContainer} ${styles.calendarContainer}`}
        >
          <div className={styles.month}>
            <IoIosArrowBack onClick={(char) => changeMonth("-")} />
            {month} - {calendarDate.getFullYear()}
            <IoIosArrowForward onClick={(char) => changeMonth("+")} />
          </div>
          <Calendar
            calendarDate={calendarDate}
            events={events}
            changeDay={(data) => changeDay(data)}
          />
        </div>
        <div className={`${styles.wrapperSecondContainer}`}>
          <Plan event={event} chosenDate={eventDate} />
        </div>
        <div className={`${styles.wrapperSecondContainer} ${styles.vademecum}`}>
          <Abc />
        </div>
      </div>
    </div>
  );
}
